export class EmbeddableContact {
  contactId?: number;
  contactName?: string;
  contactPhoneNumber?: string;
  contactEmail?: string;
  contactCompanyName?: string;

  constructor(opts?: Partial<EmbeddableContact>) {
    if (opts?.contactId != null) {
      this.contactId = opts.contactId;
    }
    if (opts?.contactName != null) {
      this.contactName = opts.contactName;
    }
    if (opts?.contactPhoneNumber != null) {
      this.contactPhoneNumber = opts.contactPhoneNumber;
    }
    if (opts?.contactEmail != null) {
      this.contactEmail = opts.contactEmail;
    }
    if (opts?.contactCompanyName != null) {
      this.contactCompanyName = opts.contactCompanyName;
    }
  }
}
